import React from "react";
import styles from "./TableManagerHeader.module.css";
import { useTableManagerContext } from "../TableManagerContext";

const TableControlButton = ({ name, handleAction, icon, control, dot=false }) => { 
  const { tableControls } = useTableManagerContext();

  return (
    <button
      data-title={name}
      key={name}
      className={styles.button}
      onClick={() =>
        handleAction({
          name,
          control,
        })
      }
    >
      <div className={styles.iconWrapper}>
        <img
          src={icon}
          alt={name}
          className={[styles.icon, tableControls[control] && styles.active].join(" ")}
        />

        {dot && <span className={styles.dot}></span>}
      </div>
    </button>
  );
};

export default TableControlButton;